export default "__VITE_ASSET__DfNdl9H9__"